// src/api/mock/heroData.js

export const heroMockData = {
  title: "Software Engineer & Technology Consultant",
  summary: "Andri Sebastian Sibarani adalah seorang Software Engineer dengan pengalaman lebih dari 10 tahun dalam pengembangan aplikasi berbasis web khususnya backend dengan teknologi C# dan .NET Core.",
  location: "Jakarta, Indonesia", // Diambil dari contact.location Anda
  name: "ANDRI SEBASTIAN",
  phone: "081362443808"
};